import { Icon } from '@chakra-ui/react';
import { TbDatabaseSearch } from 'react-icons/tb';
import { MdLayers, MdCreditCard, MdVpnKey, MdDashboard, MdPeople, MdGroups, MdSettingsInputComponent, MdGavel, MdBolt } from 'react-icons/md';
import { Role } from './models/user.model';
import Consulta from './views/consulta';
import Lotes from './views/lotes';
import Leilao from './views/leilao';
import LeadAoVivo from './views/leadAoVivo';
import Creditos from './views/creditos';
import ApiKeys from './views/apiKeys';
import Dashboard from './views/dashboard';
import Usuarios from './views/usuarios';
import Indicadores from './views/indicadores';
import Integracoes from './views/integracoes';
import MinhasApiKeys from './views/minhasApiKeys';

export interface AppRoute {
	name: string;
	layout: string;
	path: string;
	icon: JSX.Element;
	component: React.ComponentType<any>;
	roles?: Role[];
	secondary?: boolean;
	// Rótulo do grupo na sidebar. Rotas sem `section` ficam no bloco principal;
	// rotas com `section` são agrupadas sob um cabeçalho com esse nome.
	section?: string;
	// Rota acessível (fica no Router) mas escondida da sidebar — ex.: telas
	// abertas pelo menu do avatar.
	hidden?: boolean;
	// Funcionalidade liberada cliente a cliente pelo admin. Papel sozinho não
	// basta: um USER pode ter e outro não.
	feature?: 'leilao' | 'liveLead';
}

const routes: AppRoute[] = [
	{
		name: 'Consulta',
		layout: '/admin',
		path: '/consulta',
		icon: <Icon as={TbDatabaseSearch} width='20px' height='20px' color='inherit' />,
		component: Consulta
	},
	{
		name: 'Lotes',
		layout: '/admin',
		path: '/lotes',
		icon: <Icon as={MdLayers} width='20px' height='20px' color='inherit' />,
		component: Lotes
	},
	{
		name: 'Leilão',
		layout: '/admin',
		path: '/leilao',
		icon: <Icon as={MdGavel} width='20px' height='20px' color='inherit' />,
		component: Leilao,
		feature: 'leilao'
	},
	{
		name: 'Lead ao Vivo',
		layout: '/admin',
		path: '/lead-ao-vivo',
		icon: <Icon as={MdBolt} width='20px' height='20px' color='inherit' />,
		component: LeadAoVivo,
		feature: 'liveLead'
	},
	{
		name: 'Créditos',
		layout: '/admin',
		path: '/creditos',
		icon: <Icon as={MdCreditCard} width='20px' height='20px' color='inherit' />,
		component: Creditos
	},
	{
		name: 'Dashboard',
		layout: '/admin',
		path: '/dashboard',
		icon: <Icon as={MdDashboard} width='20px' height='20px' color='inherit' />,
		component: Dashboard,
		roles: [Role.ADMIN, Role.SUPORTE],
		section: 'Admin'
	},
	{
		name: 'API Keys',
		layout: '/admin',
		path: '/api-keys',
		icon: <Icon as={MdVpnKey} width='20px' height='20px' color='inherit' />,
		component: ApiKeys,
		roles: [Role.ADMIN],
		section: 'Admin'
	},
	{
		name: 'Usuários',
		layout: '/admin',
		path: '/usuarios',
		icon: <Icon as={MdPeople} width='20px' height='20px' color='inherit' />,
		component: Usuarios,
		roles: [Role.ADMIN, Role.SUPORTE],
		section: 'Admin'
	},
	{
		name: 'Indicadores',
		layout: '/admin',
		path: '/indicadores',
		icon: <Icon as={MdGroups} width='20px' height='20px' color='inherit' />,
		component: Indicadores,
		roles: [Role.ADMIN, Role.SUPORTE],
		section: 'Admin'
	},
	{
		name: 'Integrações',
		layout: '/admin',
		path: '/integracoes',
		icon: <Icon as={MdSettingsInputComponent} width='20px' height='20px' color='inherit' />,
		component: Integracoes,
		roles: [Role.ADMIN],
		section: 'Admin'
	},
	{
		// Acessível a qualquer usuário via menu do avatar / chip de créditos.
		name: 'Minhas API Keys',
		layout: '/admin',
		path: '/minhas-api-keys',
		icon: <Icon as={MdVpnKey} width='20px' height='20px' color='inherit' />,
		component: MinhasApiKeys,
		hidden: true
	}
];

export interface RouteAccess {
	role?: Role | null;
	// Flags de funcionalidade do usuário logado.
	leilaoEnabled?: boolean;
	liveLeadEnabled?: boolean;
}

export function filterRoutesByRole(list: AppRoute[], access: RouteAccess = {}): AppRoute[] {
	const { role, leilaoEnabled, liveLeadEnabled } = access;
	// ADMIN e SUPORTE enxergam as features sempre — precisam conseguir dar
	// suporte e configurar mesmo sem a flag no próprio cadastro. No Lead ao Vivo
	// é também por onde eles ligam a entrega de cada cliente.
	const isStaff = role === Role.ADMIN || role === Role.SUPORTE;
	const enabled: Record<NonNullable<AppRoute['feature']>, boolean | undefined> = {
		leilao: leilaoEnabled,
		liveLead: liveLeadEnabled
	};
	return list.filter(r => {
		if (r.roles && !(role && r.roles.includes(role))) return false;
		if (r.feature && !enabled[r.feature] && !isStaff) return false;
		return true;
	});
}

export default routes;
